import { useEffect, useState, useCallback } from "react";
import { GetQueryParam } from "../../util/helpers/funcHelper";
import { useHistory } from "react-router";

const RedirectTo = () => {
    const history = useHistory();
    const [type] = useState(GetQueryParam('type'));
    const [projectId] = useState(GetQueryParam('projectId'));

    const handleRedirect = useCallback(
        () => {
            switch (type) {
                case "project":
                    if (projectId)
                        history.push(`/console/${projectId}`)
                    break;
                default:
                    history.push(`/console`)
            }
        },
        [history, type, projectId]
    )

    useEffect(() => {
        handleRedirect();
    }, [handleRedirect])


    return (
        <>
        </>
    )
}


export default RedirectTo;